import React, { useEffect, useState } from 'react';
import BottomSection from '../components/BottomSection';
import CarouselSection from '../components/CarouselSection';
import aboutCompany from '../assets/images/about/company-intro/about-company-intro.jpg';
import aboutIdea from '../assets/images/about/brand-philosophy/about-brand-philosophy.png';
import aboutHistory from '../assets/images/about/history/about-history.png';
import aboutStrength from '../assets/images/about/strength/about-strength-01.png';
import aboutStrengthEngine1 from '../assets/images/about/strength/strength-carousel/about-strength-carousel-1.jpg';
import aboutStrengthEngine2 from '../assets/images/about/strength/strength-carousel/about-strength-carousel-2.jpg';
import aboutHonors from '../assets/images/about/honors/about-honors.png';
import aboutPartnersCarousel1 from '../assets/images/about/partner-brands/about-partner-carousel-1.png';
import aboutPartnersCarousel2 from '../assets/images/about/partner-brands/about-partner-carousel-2.png';
import aboutPartnersCarousel3 from '../assets/images/about/partner-brands/about-partner-carousel-3.png';
import aboutPartnersCarousel4 from '../assets/images/about/partner-brands/about-partner-carousel-4.png';
import aboutPartnersCarousel5 from '../assets/images/about/partner-brands/about-partner-carousel-5.png';
import aboutPartnersCarousel6 from '../assets/images/about/partner-brands/about-partner-carousel-6.png';
import aboutPartnersCarousel7 from '../assets/images/about/partner-brands/about-partner-carousel-7.png';
import aboutPartnersCarousel8 from '../assets/images/about/partner-brands/about-partner-carousel-8.jpg';
import aboutCultureImage from '../assets/images/corporate-culture-01.png';
import { useSeo } from '../seo';

const aboutPartnersCarouselSections = [
  { src: aboutPartnersCarousel1, alt: '价探合作伙伴轮播展示一' },
  { src: aboutPartnersCarousel2, alt: '价探合作伙伴轮播展示二' },
  { src: aboutPartnersCarousel3, alt: '价探合作伙伴轮播展示三' },
  { src: aboutPartnersCarousel4, alt: '价探合作伙伴轮播展示四' },
  { src: aboutPartnersCarousel5, alt: '价探合作伙伴轮播展示五' },
  { src: aboutPartnersCarousel6, alt: '价探合作伙伴轮播展示六' },
  { src: aboutPartnersCarousel7, alt: '价探合作伙伴轮播展示七' },
  { src: aboutPartnersCarousel8, alt: '价探合作伙伴轮播展示八' },
];

const aboutStrengthEngineCarouselSections = [
  { src: aboutStrengthEngine1, alt: '价探六大引擎展示一' },
  { src: aboutStrengthEngine2, alt: '价探六大引擎展示二' },
];

const aboutCompanyParagraphs = [
  '2018年，上海蜜田科技有限公司成立于上海，通过与国内高端百货达成战略联盟，开创国内首个',
  '“折扣信息+专柜买手+正品保障”的美妆平台 - 价探 PriceTag。',
  '2022年，价探 PriceTag 全面切入即时零售赛道，结合即时零售平台，持续创新科技手段，通过数字化赋能、',
  '自研中台系统，帮助国内消费者以最便捷最优惠的方式购买到放心正品。',
];

const aboutCultureStatements = [
  {
    title: '企业愿景',
    prefix: '成为年轻人身边的',
    accent: '即时美好生活品牌',
  },
  {
    title: '企业使命',
    prefix: '让美好生活所需，随时就在身边',
  },
];

const aboutCultureBeliefs = [
  ['真', '正品真货，是价探的底线'],
  ['选', '每一件商品都认真挑选，品牌品选趋势、爆品、好价格;生活品选大厂同源，高质价比'],
  ['快', '看到机会快速上新，发现问题快速调整，抓住即时零售的每一个需求窗口'],
  ['值', '不只追求低价，而是让用户买到真正质价比好物'],
  ['赢', '让用户、门店、品牌、团队，都因为价探获得更好的结果'],
];

type AboutPageProps = {
  aboutPartnersSlideIndex: number;
  setAboutPartnersSlideIndex: (index: number) => void;
};

type AboutSectionHeadingProps = {
  title: string;
  subtitle: string;
};

function AboutSectionHeading({ title, subtitle }: AboutSectionHeadingProps) {
  return (
    <header className="home-section-heading">
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </header>
  );
}

function AboutPage({
  aboutPartnersSlideIndex,
  setAboutPartnersSlideIndex,
}: AboutPageProps) {
  const [aboutStrengthEngineSlideIndex, setAboutStrengthEngineSlideIndex] = useState(0);

  useSeo('about');

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setAboutStrengthEngineSlideIndex(
        (prevIndex) => (prevIndex + 1) % aboutStrengthEngineCarouselSections.length,
      );
    }, 3200);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <main className="brand-page about-page">
      <div className="about-page-shell">
        <section className="brand-section about-poster-section about-hero-section" data-page-section="company">
          <div className="about-card about-hero-card">
            <img className="about-hero-image" src={aboutCompany} alt="价探公司简介展示" />
          </div>
          <div className="about-card about-copy-card about-company-copy-card">
            <div className="about-copy-accent" aria-hidden="true" />
            {aboutCompanyParagraphs.map((paragraph) => (
              <p key={paragraph} style={{ padding: '0px', marginTop: '-10px' }}>{paragraph}</p>
            ))}
          </div>
        </section>

        <section className="brand-section about-poster-section" data-page-section="idea" style={{ marginTop: '3%' }}>
          <AboutSectionHeading title="品牌理念" subtitle="Brand Philosophy" />
          <div className="about-card">
            <img className="about-poster-image" src={aboutIdea} alt="价探品牌理念展示" />
          </div>
          <div className="about-card about-copy-card about-idea-card">
            <p className="about-idea-slogan">美妆不用等 甄选在身边</p>
            <p>
              价探 PriceTag 致力于为消费者提供正品、好用、兼具口碑和性价比的美妆购物体验。
            </p>
            <p style={{ padding: '0px', marginTop: '-10px' }}>我们相信，变美不应等待，每个人都应该能够轻松获得高品质的美妆产品。</p>
          </div>
        </section>

        <section className="brand-section about-poster-section" data-page-section="history" style={{ marginTop: '3%' }}>
          <AboutSectionHeading title="发展历程" subtitle="Development History" />
          <div className="about-card about-history-card">
            <img className="about-poster-image" src={aboutHistory} alt="价探发展历程展示" />
          </div>
        </section>

        <section className="brand-section about-poster-section about-strength-section" data-page-section="strength">
          <AboutSectionHeading title="品牌实力" subtitle="Brand Strength" />
          <div className="about-card about-strength-hero-card">
            <img className="about-poster-image" src={aboutStrength} alt="价探品牌实力展示" />
          </div>
          <div className="about-strength-carousel-shell">
            <CarouselSection
              ariaLabel="价探六大引擎轮播展示"
              currentIndex={aboutStrengthEngineSlideIndex}
              onSelect={setAboutStrengthEngineSlideIndex}
              slides={aboutStrengthEngineCarouselSections}
            />
          </div>
        </section>

        <section className="brand-section about-poster-section" data-page-section="honors" style={{ marginTop: '3%' }}>
          <AboutSectionHeading title="所获荣誉" subtitle="Honors Rewarded" />
          <div className="about-card about-honors-card">
            <img className="about-poster-image" src={aboutHonors} alt="价探所获荣誉展示" />
          </div>
        </section>

        <section className="brand-section about-poster-section about-partners-section" data-page-section="partners" style={{ marginTop: '3%' }}>
          <AboutSectionHeading title="合作品牌" subtitle="Partner Brands" />
          <div className="about-partners-carousel-shell">
            <CarouselSection
              ariaLabel="价探合作伙伴轮播展示"
              currentIndex={aboutPartnersSlideIndex}
              onSelect={setAboutPartnersSlideIndex}
              slides={aboutPartnersCarouselSections}
            />
          </div>
        </section>

        <section className="brand-section about-poster-section about-culture-section" data-page-section="culture" style={{ marginTop: '3%' }}>
          <AboutSectionHeading title="企业文化" subtitle="Corporate Culture" />
          <div className="about-card about-culture-image-card">
            <img className="about-poster-image" src={aboutCultureImage} alt="价探企业文化展示" />
          </div>
          <div className="about-card about-culture-copy-card">
            <div className="about-culture-layout">
              <div className="about-culture-lines">
                {aboutCultureStatements.map((item) => (
                  <article className="about-culture-line" key={item.title}>
                    <h3>{item.title}</h3>
                    <div className="about-culture-line-divider" aria-hidden="true" />
                    <p>
                      {item.prefix}
                      {item.accent ? <span>{item.accent}</span> : null}
                    </p>
                  </article>
                ))}
                <article className="about-culture-line about-culture-line-values">
                  <h3>核心价值观</h3>
                  <div className="about-culture-line-divider" aria-hidden="true" />
                  <div className="about-culture-beliefs">
                    {aboutCultureBeliefs.map(([title, detail]) => (
                      <p key={title}>
                        <span>{title}</span>
                        {detail}
                      </p>
                    ))}
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>

      <BottomSection />
    </main>
  );
}

export default AboutPage;
